import './render-alert.css';
import RenderAlertTpl from './render-alert.html';
//
const compConfig = {
	template: RenderAlertTpl,
	controller: RenderAlertsController,
	bindings: {
		alertType: '<',
		alertMsg: '<',
		alertShow: '<',
		isDismissible: '<?',
	},
};
/** @ngInject */
function RenderAlertsController($timeout) {
	const $ctrl = this;
	let _prevType;
	let _closeTimer = null;
	$ctrl.$onInit = () => {
		$ctrl.alertClasses = 'alert-' + $ctrl.alertType;
		_prevType = $ctrl.alertType;
		$ctrl.close = close;
	};
	$ctrl.$onChanges = changesObj => {
		if (changesObj.alertType && !changesObj.alertType.isFirstChange()) {
			$ctrl.alertClasses = $ctrl.alertClasses.replace(_prevType, changesObj.alertType.currentValue);
		}
	};
	$ctrl.$onDestroy = () => {
		$timeout.cancel(_closeTimer);
	};

	function close() {
		_closeTimer = $timeout(() => {
			$ctrl.alertShow = false;
		}, 100);
	}
}
//
let compMod = angular.module('mod.cmp.renderAlert', []).component('renderAlert', compConfig);
export default (compMod = compMod.name);
